var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message_founder"},_vm._l((_vm.pageCate.list),function(item){return _c('div',{key:item.id},[_c('el-image',{attrs:{"src":item.image,"preview-src-list":[item.image],"fit":"cover"}}),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.summary))])])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d76210a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/go/messageFounderG.vue
// module id = null
// module chunks = 